import { render, staticRenderFns } from "./AutocompleteField.vue?vue&type=template&id=1b4c136c&scoped=true"
import script from "./AutocompleteField.vue?vue&type=script&lang=js"
export * from "./AutocompleteField.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteField.vue?vue&type=style&index=0&id=1b4c136c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c136c",
  null
  
)

export default component.exports